import type { App } from 'vue'
import { createFromIconfontCN } from '@ant-design/icons-vue'

export const Iconfont = createFromIconfontCN({
  scriptUrl: ['/iconfont/1xod8peyc31.js'],
})

export function useIconfont(app: App) {
  app.component('Iconfont', Iconfont)
}
